require('./bootstrap');

// c3.js
window.c3 = require('c3');
//Swiper
window.Swiper = require('swiper/bundle').Swiper;
